import React from 'react';
import { Check } from 'lucide-react';

export const UNCredibilitySection = () => {
  const verifiedStatus = [
    'A legitimate civil society organization operating to international standards',
    'An entity aligned with UN safeguarding and accountability frameworks',
    'A potential collaborator for UN agencies and global institutions',
    'A nonprofit committed to transparency, ethical operations, and measurable impact'
  ];

  return (
    <section id="un-credibility" className="py-20" style={{ backgroundColor: 'var(--pink-blush)' }}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="lhsc-heading text-3xl md:text-4xl mb-6">
            INSTITUTIONAL ALIGNMENT & CREDIBILITY.
          </h2>
        </div>

        {/* Body Content */}
        <div className="lhsc-body space-y-6 mb-12">
          <p>
            The Lady Hustler Society Club is officially registered on the{' '}
            <strong style={{ fontWeight: 400 }}>United Nations Partner Portal</strong> — 
            the UN's centralized system for collaboration with civil society organizations worldwide.
          </p>
          <p>
            The UN Partner Portal is not a directory anyone can join. It requires formal verification, 
            governance documentation, and demonstrated capacity. Being listed signals that LHSC is built for 
            institutional-grade partnerships — while remaining grassroots in heart and hyper-local in execution.
          </p>
        </div>

        {/* Four Verified Status Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {verifiedStatus.map((status, index) => (
            <div
              key={index}
              className="bg-white p-6 border-l-4 border-[var(--blue-periwinkle)] flex items-start"
            >
              <Check size={24} className="mr-4 flex-shrink-0 mt-1" style={{ color: 'var(--mauve-rose)' }} />
              <p className="lhsc-body text-sm">{status}</p>
            </div>
          ))}
        </div>

        {/* Credibility Strip */}
        <div className="text-center">
          <div className="lhsc-subheading text-xs leading-relaxed" style={{ color: 'var(--slate-grey)' }}>
            FEDERALLY REGISTERED NONPROFIT (CANADA)<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            UN PARTNER PORTAL<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            GOOGLE FOR NONPROFITS<br />
            CRA & REVENU QUÉBEC COMPLIANT<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            AUDIT-READY MEL SYSTEMS<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            SDG 5 ALIGNED
          </div>
        </div>
      </div>
    </section>
  );
};
